var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticClass: "pr-2 actions-menu__menu",
      attrs: {
        "offset-y": "",
        bottom: "",
        transition: "slide-x-transition",
        "nudge-width": 350,
        "close-on-content-click": false,
        "content-class": "menu-content__entity"
      },
      model: {
        value: _vm.dtActionOpen,
        callback: function($$v) {
          _vm.dtActionOpen = $$v
        },
        expression: "dtActionOpen"
      }
    },
    [
      _c(
        "v-btn",
        {
          attrs: {
            slot: "activator",
            fab: "",
            dark: "",
            small: "",
            color: _vm.dtActionOpen ? "secondary" : "primary"
          },
          slot: "activator"
        },
        [_c("v-icon", { attrs: { dark: "" } }, [_vm._v("more_horiz")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list",
        { staticClass: "actions-menu__list" },
        [
          _vm.auths.edit
            ? _c(
                "v-list-tile",
                {
                  attrs: { disabled: !_vm.auths.edit },
                  on: { click: _vm.handleEdit }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.auths.edit ? "primary" : "greyLight"
                          }
                        },
                        [_vm._v("edit")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    { class: { disabled: !_vm.auths.edit } },
                    [_vm._v("\n        " + _vm._s(_vm.texts.edit) + "\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auths.edit
            ? _c("v-divider", {
                staticClass: "actions-menu__divider",
                attrs: { color: "fuchsia" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.auths.addDocToEquipment
            ? _c(
                "v-list-tile",
                {
                  attrs: { disabled: !_vm.auths.addDocToEquipment },
                  on: { click: _vm.handleAddDocToEquipment }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.auths.addDocToEquipment
                              ? "primary"
                              : "greyLight"
                          }
                        },
                        [_vm._v("upload_file")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    { class: { disabled: !_vm.auths.addDocToEquipment } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.texts.addDocToEquipment) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auths.addDocToEquipment
            ? _c("v-divider", {
                staticClass: "actions-menu__divider",
                attrs: { color: "fuchsia" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.auths.scheduleMaintenance
            ? _c(
                "v-list-tile",
                {
                  attrs: { disabled: !_vm.auths.scheduleMaintenance },
                  on: { click: _vm.handleScheduleMaintenance }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.auths.scheduleMaintenance
                              ? "primary"
                              : "greyLight"
                          }
                        },
                        [_vm._v("schedule")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    { class: { disabled: !_vm.auths.scheduleMaintenance } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.texts.scheduleMaintenance) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auths.scheduleMaintenance &&
          _vm.$route.name !== "block_vehicle_details"
            ? _c("v-divider", {
                staticClass: "actions-menu__divider",
                attrs: { color: "fuchsia" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.name !== "block_vehicle_details"
            ? _c(
                "v-list-tile",
                {
                  attrs: { disabled: !_vm.auths.delete },
                  on: { click: _vm.handleDelete }
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.auths.delete ? "primary" : "greyLight"
                          }
                        },
                        [_vm._v("delete")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    { class: { disabled: !_vm.auths.delete } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.texts.delete) + "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0770768a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0770768a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/crud-menu/template.html
// module id = null
// module chunks = 